import {GetStaticProps} from 'next'
import {createClient} from 'prismicio'
import {ButtonDocument, HomePageDocument, NavigationDocumentData, ProductDeepDiveDocumentData} from 'prismicio-types'
import {Home} from 'src/Home'
import {NAVIGATION_QUERY} from 'src/common/constants'
export default Home

export const getStaticProps: GetStaticProps<{
  navigationData: NavigationDocumentData
  page: HomePageDocument
  productDeepDiveData: ProductDeepDiveDocumentData | null
  buttonsData: ButtonDocument[]
}> = async ({locale, previewData}) => {
  const client = createClient({previewData})
  let navigationData
  let page
  let productDeepDiveData = null
  let buttonsData: ButtonDocument[] = []

  try {
    navigationData = (
      await client.getSingle('navigation', {
        fetchLinks: ['page.parent_page'],
        lang: locale,
        graphQuery: NAVIGATION_QUERY,
      })
    ).data

    page = await client.getSingle('home_page', {lang: locale})
    productDeepDiveData = (await client.getSingle('product_deep_dive', {lang: locale})).data
    buttonsData = (await client.getAllByType<ButtonDocument>('button', {lang: locale})) as ButtonDocument[]
  } catch (error) {
    navigationData = null
    page = null
    process.stderr.write(JSON.stringify(error))
  }

  if (!page || !navigationData) {
    throw new Error('Unable to get data from Prismic')
  }

  return {
    props: {
      navigationData,
      page,
      productDeepDiveData,
      buttonsData,
    },

    revalidate: Number(process.env.REVALIDATE_TIME) || 300,
  }
}
